import styled from '@emotion/styled'

export const Container = styled.div`
    margin-bottom: 4rem;

    svg {
        width: 4rem;
    }
`